import {
  IoIosAdd,
  IoIosArrowDown,
  IoIosArrowUp,
  IoIosTrash,
  IoMdTrash,
} from "react-icons/io";
import {
  questionTypes,
  SURVEY_QUESTION_LINEAR_SCALE_FIELDS,
  SURVEY_QUESTION_SELECT_FIELD,
  SURVEY_QUESTION_TYPE,
} from "../../../constants";
import {
  Container,
  LinearScaleContainer,
  LinearScaleItem,
  LinearScaleItemInput,
  LinearScaleItemLabel,
  LinearScaleMarkerInput,
  Option,
  ReadOnlySelect,
  ReadOnlySelectOption,
  ReadOnlyText,
  Select,
  SelectQuestionContainer,
  SelectQuestionMultipleSelectionCheckbox,
  SelectQuestionMultipleSelectionLabel,
  SelectQuestionNewOptionButton,
  SelectQuestionOptionActionButton,
  SelectQuestionOptionActions,
  SelectQuestionOptionContainer,
  SelectQuestionOptionInput,
} from "./styles";

export default function QuestionTypeSelect({
  readOnly = false,
  selectedType,
  linearScale = {},
  select = {},
  onChangeLinearScale = () => null,
  onChangeSelect = () => null,
  onChangeSelectedType = () => null,
}) {
  const defaultLinearScale = {
    [SURVEY_QUESTION_LINEAR_SCALE_FIELDS.FROM]: 1,
    [SURVEY_QUESTION_LINEAR_SCALE_FIELDS.TO]: 10,
  };

  const defaultSelect = {
    [SURVEY_QUESTION_SELECT_FIELD.IS_MULTIPLE_SELECTION]: false,
    [SURVEY_QUESTION_SELECT_FIELD.OPTIONS]: [],
  };

  const handleChangeType = (e) => {
    const type = questionTypes.find((type) => +type.id === +e.target.value);

    if (type.id === SURVEY_QUESTION_TYPE.LINEAR_SCALE) {
      onChangeLinearScale(defaultLinearScale);
    } else {
      onChangeLinearScale({});
    }

    if (type.id === SURVEY_QUESTION_TYPE.SELECT) {
      onChangeSelect(defaultSelect);
    } else {
      onChangeSelect({});
    }

    onChangeSelectedType(type);
  };

  const handleChangeLinearScale = (key, value) => {
    const newLinearScale = {
      ...linearScale,
      [key]: value,
    };

    onChangeLinearScale(newLinearScale);
  };

  const handleChangeSelect = (key, value) => {
    const newSelect = {
      ...select,
      [key]: value,
    };

    onChangeSelect(newSelect);
  };

  const handleAddNewSelectOption = () => {
    const newSelectOptions = [
      ...(select[SURVEY_QUESTION_SELECT_FIELD.OPTIONS] || []),
    ];

    onChangeSelect({
      ...select,
      [SURVEY_QUESTION_SELECT_FIELD.OPTIONS]: [
        ...newSelectOptions,
        `Nova opção ${newSelectOptions.length + 1}`,
      ],
    });
  };

  const handleChangeSelectOptionValue = (optionIndex, value) => {
    const newSelectOptions = [
      ...(select[SURVEY_QUESTION_SELECT_FIELD.OPTIONS] || []),
    ];

    newSelectOptions[optionIndex] = value;

    onChangeSelect({
      ...select,
      [SURVEY_QUESTION_SELECT_FIELD.OPTIONS]: newSelectOptions,
    });
  };

  const handleChangeSelectOptionOrder = (optionIndex, newIndex) => {
    const newSelectOptions = [
      ...(select[SURVEY_QUESTION_SELECT_FIELD.OPTIONS] || []),
    ];

    [newSelectOptions[optionIndex], newSelectOptions[newIndex]] = [
      newSelectOptions[newIndex],
      newSelectOptions[optionIndex],
    ];

    onChangeSelect({
      ...select,
      [SURVEY_QUESTION_SELECT_FIELD.OPTIONS]: newSelectOptions,
    });
  };

  const handleDeleteSelectOption = (optionIndex) => {
    const prevSelectOptions = [
      ...(select[SURVEY_QUESTION_SELECT_FIELD.OPTIONS] || []),
    ];

    const optionToRemove = prevSelectOptions[optionIndex];

    const newSelectOptions = prevSelectOptions.filter(
      (option) => option !== optionToRemove
    );

    onChangeSelect({
      ...select,
      [SURVEY_QUESTION_SELECT_FIELD.OPTIONS]: newSelectOptions,
    });
  };

  if (readOnly) {
    return (
      <Container>
        <ReadOnlyText>
          {selectedType?.name || questionTypes[0].name}{" "}
          {selectedType?.id === SURVEY_QUESTION_TYPE.SELECT && select[SURVEY_QUESTION_SELECT_FIELD.IS_MULTIPLE_SELECTION] && "(Múltipla escolha) "}
          {selectedType?.id === SURVEY_QUESTION_TYPE.LINEAR_SCALE && (
            <>
              de {
                linearScale[SURVEY_QUESTION_LINEAR_SCALE_FIELDS.FROM]
              } até {linearScale[SURVEY_QUESTION_LINEAR_SCALE_FIELDS.TO]}
            </>
          )}
          {selectedType?.id === SURVEY_QUESTION_TYPE.SELECT && (
            <ReadOnlySelect
              title="Opções que vão aparecer para os alunos"
              defaultValue={
                (select[SURVEY_QUESTION_SELECT_FIELD.OPTIONS] || [])[0]
              }
            >
              {(select[SURVEY_QUESTION_SELECT_FIELD.OPTIONS] || [])?.map(
                (option) => (
                  <ReadOnlySelectOption key={option}>
                    {option}
                  </ReadOnlySelectOption>
                )
              )}
            </ReadOnlySelect>
          )}
        </ReadOnlyText>
      </Container>
    );
  }

  return (
    <Container>
      <Select value={selectedType?.id} onChange={handleChangeType}>
        {questionTypes.map((type) => {
          return (
            <Option key={type.id} value={type.id}>
              {type.name}
            </Option>
          );
        })}
      </Select>
      {selectedType?.id === SURVEY_QUESTION_TYPE.LINEAR_SCALE && (
        <LinearScaleContainer>
          <LinearScaleItem>
            <LinearScaleItemLabel>De</LinearScaleItemLabel>
            <LinearScaleItemInput
              type="number"
              min={0}
              defaultValue={
                defaultLinearScale[SURVEY_QUESTION_LINEAR_SCALE_FIELDS.FROM]
              }
              value={linearScale[SURVEY_QUESTION_LINEAR_SCALE_FIELDS.FROM]}
              onChange={(e) =>
                handleChangeLinearScale(
                  SURVEY_QUESTION_LINEAR_SCALE_FIELDS.FROM,
                  e.target.value
                )
              }
            />
          </LinearScaleItem>
          <LinearScaleItem>
            <LinearScaleItemLabel>Até</LinearScaleItemLabel>
            <LinearScaleItemInput
              type="number"
              min={0}
              defaultValue={
                defaultLinearScale[SURVEY_QUESTION_LINEAR_SCALE_FIELDS.TO]
              }
              value={linearScale[SURVEY_QUESTION_LINEAR_SCALE_FIELDS.TO]}
              onChange={(e) =>
                handleChangeLinearScale(
                  SURVEY_QUESTION_LINEAR_SCALE_FIELDS.TO,
                  e.target.value
                )
              }
            />
          </LinearScaleItem>
          <LinearScaleItem>
            <LinearScaleMarkerInput
              title="Marcador inicial que aparece abaixo da primeira escala"
              placeholder="Marcardor inicial (Opcional)"
              value={linearScale[SURVEY_QUESTION_LINEAR_SCALE_FIELDS.FROM_TEXT]}
              onChange={(e) =>
                handleChangeLinearScale(
                  SURVEY_QUESTION_LINEAR_SCALE_FIELDS.FROM_TEXT,
                  e.target.value
                )
              }
            />
          </LinearScaleItem>
          <LinearScaleItem>
            <LinearScaleMarkerInput
              title="Marcador final que aparece abaixo da última escala"
              placeholder="Marcardor final (Opcional)"
              value={linearScale[SURVEY_QUESTION_LINEAR_SCALE_FIELDS.TO_TEXT]}
              onChange={(e) =>
                handleChangeLinearScale(
                  SURVEY_QUESTION_LINEAR_SCALE_FIELDS.TO_TEXT,
                  e.target.value
                )
              }
            />
          </LinearScaleItem>
        </LinearScaleContainer>
      )}
      {selectedType?.id === SURVEY_QUESTION_TYPE.SELECT && (
        <SelectQuestionContainer>
          <SelectQuestionMultipleSelectionLabel>
            <SelectQuestionMultipleSelectionCheckbox
              type="checkbox"
              defaultChecked={
                select[SURVEY_QUESTION_SELECT_FIELD.IS_MULTIPLE_SELECTION]
              }
              onChange={(e) =>
                handleChangeSelect(
                  SURVEY_QUESTION_SELECT_FIELD.IS_MULTIPLE_SELECTION,
                  e.target.checked
                )
              }
            />
            <span>Múltipla escolha</span>
          </SelectQuestionMultipleSelectionLabel>
          {(select[SURVEY_QUESTION_SELECT_FIELD.OPTIONS] || []).map(
            (option, index, options) => {
              return (
                <SelectQuestionOptionContainer key={`${index}`}>
                  <SelectQuestionOptionInput
                    value={option}
                    onChange={(e) =>
                      handleChangeSelectOptionValue(index, e.target.value)
                    }
                  />
                  <SelectQuestionOptionActions>
                    <SelectQuestionOptionActionButton
                      disabled={index === 0}
                      onClick={() =>
                        handleChangeSelectOptionOrder(index, index - 1)
                      }
                    >
                      <IoIosArrowUp />
                    </SelectQuestionOptionActionButton>
                    <SelectQuestionOptionActionButton
                      disabled={index === options.length - 1}
                      onClick={() =>
                        handleChangeSelectOptionOrder(index, index + 1)
                      }
                    >
                      <IoIosArrowDown />
                    </SelectQuestionOptionActionButton>
                    <SelectQuestionOptionActionButton
                      onClick={() => handleDeleteSelectOption(index)}
                    >
                      <IoMdTrash color="#b00020" />
                    </SelectQuestionOptionActionButton>
                  </SelectQuestionOptionActions>
                </SelectQuestionOptionContainer>
              );
            }
          )}
          <SelectQuestionNewOptionButton onClick={handleAddNewSelectOption}>
            <IoIosAdd size="1.25em" />
            <span>Nova opção</span>
          </SelectQuestionNewOptionButton>
        </SelectQuestionContainer>
      )}
    </Container>
  );
}
